import { UserSlice } from 'features/user/forms/UserPublisherForm/types'
import { CommonSchema } from './common'

export const addSchemaDefault = (user: UserSlice): CommonSchema => ({
  role: 'viewer',
  userId: user.id,
  workspaceId: '',
})
